import '../app';
import Filters from '../modules/filters';
const filtersBtn = document.getElementById('filters-btn');
if (filtersBtn instanceof HTMLButtonElement) {
    new Filters(filtersBtn);
}
const getExpandMore = (el) => {
    let isExpanded = false;
    let rotation = 180;
    const initialMaxHeight = el.style.maxHeight;
    const expandMore = document.createElement('div');
    expandMore.className = 'tuile-produit__code-specifications-pop-code__expand-more';
    const button = document.createElement('button');
    button.className = 'tuile-produit__code-specifications-pop-code__expand-more-button material-icons md-48';
    button.textContent = 'expand_more';
    button.addEventListener("click", () => {
        if (isExpanded) {
            expandMore.style.position = 'absolute';
            el.style.maxHeight = initialMaxHeight;
        }
        else {
            expandMore.style.position = 'relative';
            el.style.maxHeight = el.scrollHeight + 'px';
        }
        button.style.transform = `rotate(${rotation}deg)`;
        isExpanded = !isExpanded;
        rotation += 180;
    });
    expandMore.appendChild(button);
    return expandMore;
};
const attributs = document.getElementsByClassName('tuile-produit__code-specifications-pop-code');
Array.from(attributs).forEach((el) => {
    // La chevron « expand more » n'apparaît pas toujours pour certains clients.
    // Je soupçonne un ordinateur lent, une connexion lente, ou les deux. Cela dit, même en simulant ces conditions
    // avec la console de Google Chrome je n'arrive pas à reproduire le problème.
    // On se croise les doigts qu'en testant la condition à chaque seconde pendant 5 secondes on va réussir à corriger
    // le tir.
    let secondes = 1;
    const interval = setInterval(() => {
        if (el.scrollHeight > el.clientHeight) { // Overflow
            clearInterval(interval);
            el.appendChild(getExpandMore(el));
        }
        else if (secondes == 5) {
            clearInterval(interval);
        }
        secondes++;
    }, 1000);
});
